import { useSearchParams } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react'

export type UseQueryParamStateProps = {
  searchParam: string,
  initialValue: string,
}

export function useQueryParamState({ searchParam, initialValue }: UseQueryParamStateProps) {
  const [searchParams, setSearchParams] = useSearchParams()
  const [value, setValue] = useState(searchParams.get(searchParam) || initialValue)

  // Update local state when URL params change
  useEffect(() => {
    const paramValue = searchParams.get(searchParam) || initialValue
    setValue(paramValue)
  }, [searchParams, searchParam, initialValue])

  const handleUpateQueryParams = useCallback((newValue: string) => {
    setValue(newValue)
    setSearchParams(prev => {
      if (newValue && newValue !== '') {
        prev.set(searchParam, newValue)
      } else {
        prev.delete(searchParam)
      }
      return prev
    })
  }, [searchParam, setSearchParams])

  return [
    value,
    handleUpateQueryParams,
  ] as const
}
